import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { EntityStatus } from './entity-status.type';
import { GuidNameCode } from './guid-name-code.type';
import { IdNameCode } from './id-name-code.type';
import { IdName } from './id-name.type';
import { SupplierClassificationStatus } from './supplier/supplier-classification-status.type';
import { SupplierMdfQualificationStatusDto } from './supplier/supplier-mdf-qualification-status-dto.type';
import { SustainabilitySummary } from './supplier/sustainability-summary.type';
import { TermsAndConditions } from './terms-and-conditions.type';
import { User } from './user.type';

const SupplierLookup = t.intersection(
  [
    t.type({
      id: t.string,
      name: nullable(t.string),
    }),
    t.partial({
      guid: nullable(t.string),
      smVendorId: nullable(t.string),
      isActive: nullable(t.boolean),
      country: nullable(IdNameCode),
      state: nullable(t.string),
      city: nullable(t.string),
      zipCode: nullable(t.string),
      address: nullable(t.string),
      website: nullable(t.string),
      qualificationStatus: nullable(EntityStatus),
      mdfQualificationStatus: nullable(SupplierMdfQualificationStatusDto),
      registrationStatus: nullable(EntityStatus),
      classificationStatus: nullable(IdName),
      classificationStatuses: t.array(SupplierClassificationStatus),
      hasFrameAgreement: nullable(t.boolean),
      kpiRiskValue: nullable(t.number),
      kpiContractsCount: nullable(t.number),
      leadBuyers: nullable(t.array(User)),
      defaultTermsAndConditions: nullable(TermsAndConditions),
      latitude: nullable(t.number),
      longitude: nullable(t.number),
      type: nullable(EntityStatus),
      averageEvaluationScore: nullable(t.number),
      sustainability: nullable(SustainabilitySummary),
      existsInSap: nullable(t.boolean),
      parentSupplier: nullable(GuidNameCode),
      isTcd: nullable(t.boolean),
      isEtcd: nullable(t.boolean),
      isDuplicate: nullable(t.boolean),
      levels: t.array(t.string),
    }),
  ],
  'SupplierLookup',
);

type SupplierLookup = t.TypeOf<typeof SupplierLookup>;
export { SupplierLookup };
